import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Print } from '../../images/icons/print.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
}

const PrintButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvg}
        onClick={props.onClick}>
            <Print className={props.classes.iconButtonSvg}/>
    </MuiButton>)
}
export default withStyles(styles)(PrintButton)